import { makeStyles } from '@material-ui/core/styles'

const useAccountLinkRowStyles = makeStyles(theme => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    color: 'inherit',
    textDecoration: 'none',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#ECEFF1',
    },
  },
  iconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    width: 40,
    height: 40,
    minWidth: 40,
    minHeight: 40,
    borderRadius: '50%',
    backgroundColor: '#E0EAFF',
    flexShrink: 0,
    '& .MuiSvgIcon-root, & svg': {
      fontSize: 24,
      width: '1em',
      height: '1em',
      color: '#0053FF',
      fill: 'currentColor',
      flexShrink: 0,
    },
  },
  button: {
    width: '100%',
    margin: 0,
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
    appearance: 'none',
  },
  disabled: {
    cursor: 'not-allowed',
    '&:hover, &:disabled': {
      backgroundColor: '#F4F7F9',
    },
    '&:disabled': {
      color: 'inherit',
      opacity: 1,
    },
    '& $copy, & $chevron': {
      opacity: 0.7,
    },
  },
  copy: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  title: {
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  caption: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  chevron: {
    color: '#9EA7B0',
    flexShrink: 0,
  },
}))

export default useAccountLinkRowStyles
